import React from 'react';

/**
 * SmoothScroll Component
 * Preserves clean native 60/120fps hardware-accelerated scrolling across all modern browsers and devices.
 */
export const SmoothScroll: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

